export const safeJsonParse =(json:string)=>{
  try {
    const res = JSON.parse(json)
    return res || {}
  } catch (error) {
    console.log(error);
    return {}
  }
}